package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_05_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As the heroes near Banshir, they see rice terraces, stepped fields of rice on sloping land. The homes in Banshir are elevated on stilts. Korvis recognizes Elder Dary Darusha. The elder offers the heroes the guest hut for the night and tells them that some townsfolk will stop by cook them dinner. It isn’t often that Banshir is visited by such an unusual party of travelers.")
    }
}
